module.exports = __webpack_public_path__ + "assets/img/ICI-UK-Content-Marketing.defa10bf.jpg";